import React from 'react';
import { Helmet } from 'react-helmet';
import Mainbody from './components_admin/AdminLayout';
import './App.css';
import Login from './Pages_admin/Login';
import WebBody from './components/WebBody';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Icons from './pages/Icons';
import Interfaceicon from './pages/Interfaceicon';
import Topicon from './pages/Topicon';
import Animatedicons from './pages/Animatedicons';
import Pack from './pages/Pack';
import Topanimatedicon from './pages/Topanimatedicon';
import Support from './pages/Support';
import BlackFill from './pages/BlackFill';
import Contact from './pages/Contact';
import Faqs from './pages/Faqs';

//admin pages
import AdminLayout from './components_admin/AdminLayout'
import Dashboard from './components_admin/Dashboard';
import Icon from './Pages_admin/Icon';
import Animatedicon from './Pages_admin/Animatedicon';
import Category from './Pages_admin/Category';
import Interface from './Pages_admin/Interface';
import UserLayout from './components/UserLayout';
import { Analytics } from "@vercel/analytics/react"
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import PopularIcon from './Pages_admin/PopularIcon';
import PopularCategory from './Pages_admin/PopularCategory';
import Searchicons from './pages/Searchicons';
import UserLayoutWithout from './components/UserLayoutWithout';

function App() {
  return (
    <div>
      <Helmet>
        <title>Icon Library - Free Icons for Your Projects</title>
        <meta name="description" content="Explore our vast collection of free icons for web and mobile projects. Download SVG, PNG, and animated icons." />
        <meta name="keywords" content="icons, free icons, SVG icons, PNG icons, animated icons, interface icons, icon pack" />
      </Helmet>

      <Router>
        <Switch>

          <Route exact path='/'>
            <UserLayout>
              <Helmet>
                <title>Home - Icon Library</title>
                <meta name="description" content="Welcome to our icon library. Find and download free icons for your projects." />
              </Helmet>
              <WebBody />
            </UserLayout>
          </Route>

          <Route path='/icons'>
            <UserLayout>
              <Helmet>
                <title>Icons - Browse Our Collection</title>
                <meta name="description" content="Browse our extensive collection of icons. Find the perfect icon for your project." />
              </Helmet>
              <Icons />
            </UserLayout>
          </Route>

          <Route path='/interface-icons'>
            <UserLayout>
              <Helmet>
                <title>Interface Icons - UI/UX Design Elements</title>
                <meta name="description" content="Discover our collection of interface icons perfect for UI/UX design projects." />
              </Helmet>
              <Interfaceicon />
            </UserLayout>
          </Route>

          <Route path='/animated-icons'>
            <UserLayout>
              <Helmet>
                <title>Animated Icons - Add Motion to Your Design</title>
                <meta name="description" content="Explore our animated icons to add motion and interactivity to your designs." />
              </Helmet>
              <Animatedicons />
            </UserLayout>
          </Route>

          <Route path="/most-downloads">
            <UserLayoutWithout>
              <Helmet>
                <title>Most Downloaded Icons - Popular Choices</title>
                <meta name="description" content="Check out our most downloaded icons. See what's trending in icon design." />
              </Helmet>
              <Topicon />
            </UserLayoutWithout>
          </Route>

          {/* Search */}

          <Route path="/search-icon">
            <UserLayoutWithout>
              <Helmet>
                <title>Search Icons - Find the Perfect Icon</title>
                <meta name="description" content="Search our icon library to find the perfect icon for your project." />
              </Helmet>
              <Searchicons />
            </UserLayoutWithout>
          </Route>

          <Route path="/pack">
            <UserLayout>
              <Helmet>
                <title>Icon Packs - Curated Collections</title>
                <meta name="description" content="Browse our curated icon packs for consistent design across your projects." />
              </Helmet>
              <Pack />
            </UserLayout>
          </Route>

          <Route path="/topanimatedicon">
            <UserLayout>
              <Helmet>
                <title>Top Animated Icons - Most Popular Animations</title>
                <meta name="description" content="Explore our top animated icons. Add popular animations to your designs." />
              </Helmet>
              <Topanimatedicon />
            </UserLayout>
          </Route>

          <Route path="/contact-us">
            <UserLayout>
              <Helmet>
                <title>Contact Us - Get in Touch</title>
                <meta name="description" content="Have questions or feedback? Contact our team for support." />
              </Helmet>
              <Contact />
            </UserLayout>
          </Route>

          <Route path="/support">
            <UserLayout>
              <Helmet>
                <title>Support - Help Center</title>
                <meta name="description" content="Need help? Visit our support center for FAQs and assistance." />
              </Helmet>
              <Support />
            </UserLayout>
          </Route>

          <Route path="/faqs">
            <UserLayout>
              <Helmet>
                <title>FAQs - Frequently Asked Questions</title>
                <meta name="description" content="Find answers to common questions about our icon library and services." />
              </Helmet>
              <Faqs />
            </UserLayout>
          </Route>

          <Route path="/back-fill">
            <UserLayout>
              <Helmet>
                <title>Back Fill Icons - Solid Background Icons</title>
                <meta name="description" content="Explore our collection of back fill icons with solid backgrounds." />
              </Helmet>
              <BlackFill />
            </UserLayout>
          </Route>

          <Route path="/login">
            <Helmet>
              <title>Login - Access Your Account</title>
              <meta name="description" content="Log in to your account to access premium features and manage your icons." />
            </Helmet>
            <Login />
          </Route>

          <Route exact path="/admin" >
            <AdminLayout>
              <Helmet>
                <title>Admin Dashboard - Manage Your Icon Library</title>
                <meta name="description" content="Admin dashboard for managing icons, categories, and user accounts." />
              </Helmet>
              <Dashboard />
            </AdminLayout>
          </Route>

          <Route path="/admin/icons/icon">
            <AdminLayout>
              <Helmet>
                <title>Manage Icons - Admin Panel</title>
                <meta name="description" content="Add, edit, or remove icons from your library in the admin panel." />
              </Helmet>
              <Icon />
            </AdminLayout>
          </Route>

          <Route path="/admin/popular-icon/icon">
            <AdminLayout>
              <Helmet>
                <title>Manage Popular Icons - Admin Panel</title>
                <meta name="description" content="Curate and manage the list of popular icons in the admin panel." />
              </Helmet>
              <PopularIcon />
            </AdminLayout>
          </Route>

          <Route path="/admin/popular-icon/category">
            <AdminLayout>
              <Helmet>
                <title>Manage Popular Categories - Admin Panel</title>
                <meta name="description" content="Organize and manage popular icon categories in the admin panel." />
              </Helmet>
              <PopularCategory />
            </AdminLayout>
          </Route>

          <Route path="/admin/icons/animated-icon">
            <AdminLayout>
              <Helmet>
                <title>Manage Animated Icons - Admin Panel</title>
                <meta name="description" content="Add, edit, or remove animated icons in the admin panel." />
              </Helmet>
              <Animatedicon />
            </AdminLayout>
          </Route>

          <Route path="/admin/icons/interface-Icon">
            <AdminLayout>
              <Helmet>
                <title>Manage Interface Icons - Admin Panel</title>
                <meta name="description" content="Curate and manage interface icons in the admin panel." />
              </Helmet>
              <Interface />
            </AdminLayout>
          </Route>

          <Route path="/admin/category">
            <AdminLayout>
              <Helmet>
                <title>Manage Categories - Admin Panel</title>
                <meta name="description" content="Create, edit, or remove icon categories in the admin panel." />
              </Helmet>
              <Category />
            </AdminLayout>
          </Route>

        </Switch>

      </Router>
      <Analytics />
    </div>
  );
}

export default App;
